// extracted by mini-css-extract-plugin
export default {"container":"excluded_container__VK9Pk","backButton":"excluded_backButton__4RRME","contentcontainer":"excluded_contentcontainer__ZCuf0","icon":"excluded_icon__ujCIl"};